import { render, staticRenderFns } from "./TabSafetyInstructions.vue?vue&type=template&id=330d021e&scoped=true&"
import script from "./TabSafetyInstructions.vue?vue&type=script&lang=js&"
export * from "./TabSafetyInstructions.vue?vue&type=script&lang=js&"
import style0 from "./TabSafetyInstructions.vue?vue&type=style&index=0&id=330d021e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d021e",
  null
  
)

export default component.exports